import React from 'react';

interface ApplePayButtonProps {
  buttonstyle?: 'white' | 'black';
  appleType?: 'pay' | 'buy';
  locale?: string;
  disabled?: boolean;
}

const ApplePayButton: React.FC<ApplePayButtonProps> = ({
  buttonstyle = 'black',
  appleType = 'pay',
  locale = 'en-US',
  disabled = false,
}) => {
  // Create the apple-pay-button element that Apple Pay JS will enhance
  return React.createElement('apple-pay-button', {
    buttonstyle,
    type: appleType,
    locale,
    disabled,
  });
};

export default ApplePayButton;
